<template>
	<core-modal
		:name="campaign.id + '-archive-modal'"
		class="omapi-modal archive-modal"
		:click-to-close="!isArchiving"
		:is-confirmation="true"
		:child-refs="$refs"
	>
		<modals-content>
			<form @submit.prevent="archive">
				<p>
					Are you sure you want to archive the
					<strong>{{ campaign.name }} ({{ campaign.id }})</strong> campaign? This will also archive all of its
					split tests.
				</p>

				<section class="buttons">
					<core-loading-button
						ref="toFocus"
						class="archive-campaign"
						color="blue"
						size="large"
						button-type="submit"
						:loading="isArchiving"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						:disabled="isArchiving"
						@click.prevent="$modal.hide(campaign.id + '-archive-modal')"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { archive } from '@/campaigns/mixins/archive';

export default {
	mixins: [archive],
	props: {
		campaign: {
			type: Object,
			required: true,
		},
	},
};
</script>
